import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';

export default class MonthlyVatReportExpenseSCCD extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentExpense: props.currentExpense || null,
      currentJob: props.currentJob || null,
      momentFormatString: 'ddd Do MMM YYYY',
      momentFormatStringCSV: 'ddd Do MMM YYYY - HHmmss',
    };
  }
  render() {
    return (
      <div className="row monthly-vat-report-expense-container">
        <div className="col-md-2 col-sm-12 text-left">
          <a
            href={"/jobs/view/"+this.state.currentJob['job']['id']}
            target="_blank"
            className="btn btn-sm btn-dark"
          >
            <i className="fa fa-arrow-alt-circle-right"></i>&nbsp;
            {this.state.currentJob['job']['id']}
          </a>
        </div>
        <div className="col-md-2 col-sm-12 text-left">
          &pound;{
            parseFloat(this.state.currentExpense['clean']['NET_AMOUNT']).
            toFixed(2)
          }
        </div>
        <div className="col-md-2 col-sm-12 text-left">
          &pound;{
            parseFloat(this.state.currentExpense['clean']['TAX_AMOUNT']).
            toFixed(2)
          }
        </div>
        <div className="col-md-1 col-sm-12 text-left">
          &pound;{
          parseFloat(this.state.currentExpense['clean']['SERVICE_AMOUNT']).
          toFixed(2)
        }
        </div>
        <div className="col-md-1 col-sm-12 text-right">
          {this.state.currentExpense['clean']['SERVICE_TEXT']}
        </div>
        <div className="col-md-4 col-sm-12 text-center">
            <button
            className="monthly-vat-report-vat-claimed-button btn btn-sm btn-dark"
          >
            <i className="fa fa-window-close"></i>&nbsp;
            VAT Claimed
          </button> 
          {this.state.currentJob['job']['registration_number']}
          <span className="textright">&pound;{(
            parseFloat(this.state.currentExpense['clean']['NET_AMOUNT']) +
            parseFloat(this.state.currentExpense['clean']['TAX_AMOUNT'])
            ).toFixed(2)
            }</span>
        </div>
        
      </div>
    );
  }
}
